import React, { useRef } from 'react'
import { connect } from 'react-redux'
import { Field, Form, formValueSelector, reduxForm, change } from 'redux-form'
import { useHistory } from 'react-router-dom'
import styled from '@emotion/styled'
import { KeyboardArrowDown } from '@material-ui/icons'

import Pagination from '@material-ui/lab/Pagination'
import { makeStyles, useTheme } from '@material-ui/styles'
import AsyncSelect from '../shared/AsyncSelect'
import { roles } from '../../utils/constants'
import StyledSVG from '../shared/StyledSVG'
import doneSVG from '../../assets/icons/status-confirmation.svg'
import clipboardSVG from '../../assets/icons/report-clipboard.svg'
import pendingSVG from '../../assets/icons/status-pending.svg'
import openSVG from '../../assets/icons/status-open.svg'
import moderatingSVG from '../../assets/icons/moderating-icon.svg'
import viewSVG from '../../assets/icons/pattern-view-iconV2.svg'
import editSVG from '../../assets/icons/pattern-edit-iconV2.svg'
import generateReportSVG from '../../assets/icons/generate-reportV2.svg'

import { generateReports } from '../../store/reports/actions'
import CustomTable from '../table/CustomTable'
import moment from 'moment'
import { showAlertMessage } from '../../store/alert/actions'
import { CircularProgress, Tooltip, useMediaQuery } from '@material-ui/core'
import AvatarList from '../shared/AvatarList'

const ReportItem = styled('div')(({ theme, iconColor }) => ({
  backgroundColor: '#FFFFFF',
  borderRadius: 16,
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  minHeight: 80,
  gap: 16,
  padding: 16,
  position: 'relative',
  '& .report_infos': {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column'
  },
  '& .title': {
    fontWeight: 500,
    margin: 0,
    fontSize: 16
  },
  '& .author': {
    color: '#ADB8CC',
    fontWeight: 400,
    fontSize: 14,
    margin: 0
  },
  '& path': {
    fill: iconColor
  }
}))

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: '40px 30px',
    height: '100%',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    [theme.breakpoints.down('750')]: {
      backgroundColor: 'unset'
    }
  },
  pageLabel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 20,
    '& h1': {
      fontSize: 32,
      color: '#386093',
      fontWeight: 700,
      margin: 0
    },
    '& span': {
      color: '#555555',
      fontSize: 16
    }
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 45,
    [theme.breakpoints.down('890')]: {
      flexDirection: 'column-reverse',
      gap: 16
    }
  },
  searchSection: {
    marginTop: 40
  },
  searchDiv: {
    '& .MuiInputBase-root': {
      width: 300,
      [theme.breakpoints.down('426')]: {
        maxWidth: '250px'
      },
      [theme.breakpoints.down('330')]: {
        maxWidth: 220
      }
    }
  },
  filtersSection: {
    display: 'flex',
    flexDirection: 'column'
  },
  filterLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  advancedFilter: {
    overflow: 'hidden',
    transition: 'height 0.5s ease-in-out',
    [theme.breakpoints.down('1000')]: {
      overflow: 'scroll'
    }
  },
  filtersDisplay: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 24
  },
  searchGroup: props => ({
    transition: 'opacity 0.3s ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
    alignItems: 'left',
    gap: 24,
    '& .title': {
      margin: '10px',
      color: '#4D5E80',
      fontFamily: 'Montserrat',
      fontSize: '28px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '120%',
      marginLeft: 0,
      [theme.breakpoints.down(900)]: {
        textAlign: 'center'
      }
    },
    '& .filterFields': {
      display: 'flex',
      gap: 20,
      flexWrap: 'wrap',
      [theme.breakpoints.down('750')]: {
        alignItems: 'center',
        flexDirection: 'column'
      }
    },
    [theme.breakpoints.down('900')]: {
      flexDirection: 'column',
      gap: 12
    }
  }),
  searchField: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    '& .select__control': {
      height: 48
    },
    '& .select__value-container': {
      height: 48
    },
    '& label': {
      fontFamily: 'Montserrat',
      fontWeight: 600,
      fontStyle: 'SemiBold',
      fontSize: '12px',
      leadingTrim: 'NONE',
      lineHeight: '100%',
      letterSpacing: '0%',
      color: '#868E96'
    },
    '& .select__menu-list': {
      maxHeight: '150px'
    },
    '& div': {
      '& .select__control': {
        minWidth: 216
      }
    },
    [theme.breakpoints.down('1500')]: {
      alignItems: 'flex-start',
      flexDirection: 'column'
    },
    [theme.breakpoints.down('750')]: {
      width: '100%'
    },
    [theme.breakpoints.down('350')]: {
      width: 'unset'
    }
  },
  asyncSelectClass: {
    [theme.breakpoints.down('750')]: {
      width: '100%'
    }
  },
  react_select: {
    width: '100%',
    height: 50,
    '& .select__control': {
      height: 50
    },
    '& .select__menu-list': {
      maxHeight: '188px'
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    gap: 8,
    '& button': {
      marginRight: 0,
      width: 149
    },
    [theme.breakpoints.down('1000')]: {
      justifyContent: 'flex-start',
      marginTop: 15,
      flexDirection: 'column-reverse',
      alignItems: 'center',
      '& button': {
        width: '200px !important'
      }
    },
    [theme.breakpoints.down('350')]: {
      '& button': {
        width: '170px !important'
      }
    }
  },
  horizontalBar: {
    marginBottom: 27,
    width: '96%',
    height: 1,
    border: '1px solid #E7EAF0'
  },
  clearBtn: {
    backgroundColor: '#EF7C8F',
    width: 154,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  applyBtn: {
    backgroundColor: '#386093',
    width: 154,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  createBtn: {
    backgroundColor: '#00ACDB',
    width: 146,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#00ACDB'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  actionsSection: {
    display: 'flex',
    gap: 5,
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      '&:hover': {
        cursor: 'pointer'
      }
    }
  },
  responsive_results_root: {
    display: 'flex',
    flexDirection: 'column',
    '& .title': {
      fontWeight: 600,
      margin: 0,
      fontSize: 20,
      color: '#386093'
    }
  },
  reports_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16,
    marginTop: 24
  },
  arrow: {
    transform: 'rotate(-90deg)',
    position: 'absolute',
    right: 12
  },
  report_item_responsive_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 12,
    '& .report-date': {
      textAlign: 'flex-start',
      color: '#ADB8CC',
      fontWeight: 500,
      fontSize: 12,
      margin: 0
    }
  },
  report_item: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minHeight: 80,
    gap: 16,
    padding: 16,
    '& .report_infos': {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column'
    },
    '& .title': {
      fontWeight: 500,
      margin: 0,
      fontSize: 16
    },
    '& .author': {
      color: '#ADB8CC',
      fontWeight: 400,
      fontSize: 14,
      margin: 0
    }
  },
  pagination: {
    marginTop: 12
  }
}))

const ResponsiveReportsResults = ({
  pagination,
  data,
  isFetching,
  fetchItems,
  params,
  handleGenerateReport,
  history,
  statusProperties
}) => {
  const classes = useStyles()
  const [page, setPage] = React.useState(1)

  const handleChange = (event, value) => {
    setPage(value)
    fetchItems({
      page: value,
      params
    })
  }
  const handleClickReports = report => {
    handleGenerateReport(report.id, report.user_id, generateReports)
    setTimeout(() => {
      history.push(`/report_template/${report.id}`)
    }, 1000)
  }

  if (isFetching) return <CircularProgress />
  if (data.length === 0) return <p>Nenhum resultado obtido</p>
  return (
    <div className={classes.responsive_results_root}>
      <h1 className='title'>Últimos diários criados</h1>
      <div className={classes.reports_wrapper}>
        {data?.map(report => {
          return (
            <div
              onClick={() => handleClickReports(report)}
              className={classes.report_item_responsive_wrapper}
              key={`report-${report.id}`}
            >
              <p className='report-date'>
                {moment(report.created_at).format('ddd D MMMM YYYY')}
              </p>
              <ReportItem iconColor={statusProperties(report.status, true)}>
                <StyledSVG src={clipboardSVG} width={24} height={24} />
                <div className='report_infos'>
                  <h1 className='title'>{report.title}</h1>
                  <h1 className='author'>{report.user.name}</h1>
                </div>
                <KeyboardArrowDown className={classes.arrow} />
              </ReportItem>
            </div>
          )
        })}
      </div>
      <div className={classes.pagination}>
        {pagination &&
          pagination.pageCount > 1 &&
          !isFetching && (
            <Pagination
              count={pagination.pageCount}
              siblingCount={0}
              page={page}
              onChange={handleChange}
              color={'primary'}
            />
          )}
      </div>
    </div>
  )
}

const SearchReportsForm = ({
  alert,
  change,
  handleSubmit,
  gradeValue,
  schoolValue,
  startDateValue,
  classroomValue,
  studentValue,
  userOccupations,
  getReports,
  reports,
  reset,
  touch,
  generateReports,
  handleGenerateReport,
  defaultParams,
  nameValue,
  schoolId,
  teacherValue
}) => {
  const isAdmin =
    userOccupations?.includes(roles.SCHOOL_ADMIN) ||
    userOccupations?.includes(roles.VERSAR_ADMIN)
  const isCoordinator = userOccupations?.includes(roles.COORDINATOR)
  const classes = useStyles({ isAdmin })
  const history = useHistory()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('426'))
  const smallDisplay = useMediaQuery(theme.breakpoints.down('750'))

  const selectSchoolRef = useRef(null)
  const selectGradeRef = useRef(null)
  const selectClassroomRef = useRef(null)
  const selectTeacherRef = useRef(null)

  Object.assign(defaultParams, { 'q[classroom_school_id_eq]': schoolValue })

  const handleChange = (event, input) => {
    touch()
    let newValue
    if (Array.isArray(event)) {
      newValue = event?.map(v => v)
    } else {
      newValue = event ? event.value : ''
    }
    change(input.name, newValue)
  }

  const statusProperties = (status, isForColor) => {
    switch (status) {
      case 'done': {
        if (isForColor) return '#9DD2DA'
        return doneSVG
      }
      case 'pending': {
        if (isForColor) return '#EF7C8F'
        return pendingSVG
      }
      case 'open': {
        if (isForColor) return '#C4C4C4'
        return openSVG
      }
      case 'waiting_moderation': {
        if (isForColor) return '#8B598E'
        return moderatingSVG
      }
      case 'refused': {
        if (isForColor) return '#743b3bff'
        return moderatingSVG
      }
      default:
        return ''
    }
  }

  const startDateValueAux = startDateValue && new Date(startDateValue)
  const searchParams = {
    ...defaultParams,
    'q[title_eq]': nameValue,
    'q[classroom_id_eq]': classroomValue,
    'q[classroom_grade_id_eq]': gradeValue,
    'q[classroom_school_id_eq]': schoolValue,
    'q[classroom_teachers_id_eq]': teacherValue,
    'q[classroom_children_id_eq]': studentValue,
    'q[created_at_gteq]': startDateValue
      ? moment(startDateValue).format('YYYY-MM-DD')
      : null,
    'q[created_at_lteq]': startDateValue
      ? moment(
          new Date(startDateValueAux.setDate(startDateValueAux.getDate() + 1))
        ).format('YYYY-MM-DD')
      : null
  }

  React.useEffect(
    () => {
      getReports({ params: searchParams })
    },
    [schoolValue, gradeValue, classroomValue, teacherValue]
  )

  const columns = [
    {
      key: 'grade',
      name: 'Série',
      width: isAdmin ? '5%' : '15%',
      align: 'center',
      render: row => {
        let title
        matches
          ? (title = row.classroom?.[0]?.grade.name)
          : (title = `${row.classroom?.[0]?.grade.name.slice(0, 10)}...`)
        return (
          <Tooltip title={row.classroom?.[0]?.grade.name}>
            <span>{title}</span>
          </Tooltip>
        )
      }
    },
    {
      key: 'classroom',
      name: 'Turma',
      width: isAdmin ? '25%' : '15%',
      align: 'center',
      render: row => {
        let classrooms = []
        row.classroom?.map(clas => {
          classrooms.push(clas?.name)
        })
        return classrooms
      }
    },
    ...(isAdmin
      ? [
          {
            key: 'teacher',
            name: 'Professor',
            width: '25%',
            align: 'center',
            render: row => {
              return <AvatarList data={row?.classroom?.[0]?.teachers || []} />
            }
          }
        ]
      : []),
    {
      key: 'date',
      name: 'Data da criação',
      width: '15%',
      align: 'center',
      render: function render (row) {
        return moment(row.created_at).format('DD/MM/YYYY HH:mm')
      }
    },
    {
      key: 'actions',
      name: 'Ações',
      width: isAdmin ? '5%' : '15%',
      align: 'center',
      render: function render (row) {
        return (
          <div className={classes.actionsSection}>
            {(isAdmin || isCoordinator) && (
              <Tooltip style={{ justifyContent: '' }} title='Visualizar'>
                <div onClick={() => history.push(`report_template/${row.id}`)}>
                  <StyledSVG src={viewSVG} width={20} height={20} />
                </div>
              </Tooltip>
            )}
            {
              <Tooltip
                title={isAdmin || isCoordinator ? 'Gerar diário' : 'Visualizar'}
              >
                <div
                  onClick={() => {
                    handleGenerateReport(row.id, row.user_id, generateReports)
                    setTimeout(() => {
                      history.push(`/report_template/${row.id}`)
                    }, 1000)
                  }}
                >
                  <StyledSVG
                    src={isAdmin || isCoordinator ? generateReportSVG : viewSVG}
                    width={20}
                    height={20}
                  />
                </div>
              </Tooltip>
            }
            {(isAdmin || isCoordinator) && (
              <Tooltip title={'Editar'}>
                <div
                  onClick={() =>
                    history.push(`report_template/${row.id}?name=edit`)
                  }
                >
                  <StyledSVG src={editSVG} width={20} height={20} />
                </div>
              </Tooltip>
            )}
          </div>
        )
      }
    }
  ]

  return (
    <div className={classes.root}>
      <Form onSubmit={handleSubmit}>
        <div className={classes.filtersDisplay}>
          <div className={classes.searchGroup}>
            <h1 className='title'>
              {smallDisplay
                ? 'Filtros'
                : isAdmin ? 'Últimos diários criados' : 'Diários da semana'}
            </h1>
            <div className='filterFields'>
              {userOccupations?.includes(roles.VERSAR_ADMIN) && (
                <div className={classes.searchField}>
                  <strong htmlFor='school_id'>Escola</strong>
                  <Field
                    style={{ width: '100%' }}
                    component={AsyncSelect}
                    selectRef={selectSchoolRef}
                    id='school_id'
                    name='school_id'
                    placeholder='Digite ou selecione a escola'
                    handleAsyncChange={handleChange}
                    searchParam='q[name_cont]'
                    request={{
                      path: 'school'
                    }}
                    touch={touch}
                  />
                </div>
              )}
              {isAdmin && (
                <div className={classes.searchField}>
                  <label htmlFor={`grade_id`}>Série:</label>
                  <Field
                    component={AsyncSelect}
                    defaultOptions={false}
                    rootStyle={classes.asyncSelectClass}
                    id='grade_id'
                    name='grade_id'
                    selectRef={selectGradeRef}
                    placeholder='Digite ou selecione'
                    handleAsyncChange={handleChange}
                    searchParam='q[name_cont]'
                    request={{
                      path: 'grade',
                      params: {
                        'q[school_id_eq]': schoolValue,
                        'q[m]': 'or',
                        'q[school_id_null]': true
                      }
                    }}
                    touch={touch}
                  />
                </div>
              )}
              {isAdmin && (
                <div className={classes.searchField}>
                  <label htmlFor={`teacher_id`}>Professor(a):</label>
                  <Field
                    component={AsyncSelect}
                    selectRef={selectTeacherRef}
                    rootStyle={classes.asyncSelectClass}
                    id='teacher_id'
                    name='teacher_id'
                    placeholder='Digite ou selecione'
                    handleAsyncChange={handleChange}
                    searchParam='q[teacher_name_cont]'
                    request={{
                      path: 'school_teachers',
                      params: {
                        'q[school_id_eq]': schoolId || schoolValue,
                        include: 'teacher'
                      }
                    }}
                    touch={touch}
                  />
                </div>
              )}
              <div className={classes.searchField}>
                <label htmlFor={`classroom_id`}>Turma:</label>
                <Field
                  component={AsyncSelect}
                  defaultOptions={false}
                  rootStyle={classes.asyncSelectClass}
                  id='classroom_id'
                  name='classroom_id'
                  selectRef={selectClassroomRef}
                  placeholder='Digite ou selecione'
                  handleAsyncChange={handleChange}
                  searchParam='q[name_cont]'
                  request={{
                    path: 'classroom',
                    params: {
                      'q[school_id_in]': schoolValue,
                      'q[grade_id_in]': gradeValue,
                      'q[year_lteq]': new Date().getFullYear() + 1,
                      'q[year_gteq]': new Date().getFullYear()
                    }
                  }}
                  touch={touch}
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          {smallDisplay ? (
            <ResponsiveReportsResults
              handleGenerateReport={handleGenerateReport}
              history={history}
              data={reports.items}
              params={searchParams}
              fetchItems={getReports}
              isFetching={reports.isFetching}
              pagination={reports.pagination}
              statusProperties={statusProperties}
            />
          ) : (
            <CustomTable
              columns={columns}
              from={'reports'}
              data={reports.items}
              params={searchParams}
              fetchItems={getReports}
              isFetching={reports.isFetching}
              pagination={reports.pagination}
              columnsPointer={[0]}
              border={'none'}
              alignHeadTable={'center'}
              headCellRadius
              headColor={'rgba(173, 184, 204, 0.3)'}
            />
          )}
        </div>
      </Form>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  const selector = formValueSelector('searchReportsForm')

  return {
    userOccupations: state.auth.currentOccupation,
    schoolValue:
      selector(state, 'school_id') ||
      (state.school.currentSchool && state.school.currentSchool.school_id),
    classroomValue: selector(state, 'classroom_id'),
    gradeValue: selector(state, 'grade_id'),
    nameValue: selector(state, 'name'),
    startDateValue: selector(state, 'start_at'),
    teacherValue: selector(state, 'teacher_id'),
    schoolId: state.school.currentSchool && state.school.currentSchool.school_id
  }
}

const mapDispatchToProps = dispatch => ({
  generateReports: data => dispatch(generateReports(data)),
  change: (field, data) => dispatch(change('searchReportsForm', field, data)),
  alert: (message, type) =>
    dispatch(
      showAlertMessage({
        message: message,
        severity: type
      })
    )
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'searchReportsForm'
  })(SearchReportsForm)
)
